import { apiMain } from "@/common/services";
import {
  AddedToCollectionEvent,
  FollowUserClickedEvent,
  GifLikedEvent,
  GifPlaybackEvent,
  GifSharedEvent,
  GifViewEvent,
  ProfileClickedEvent
} from "@/common/buses";
import { GifMetricsEvent } from "@/common/services/RedGifsService";

class LocalMetrics {
  async sendGifView(props: GifViewEvent): Promise<void> {
    try {
      await apiMain.sendGifMetrics({
        event: GifMetricsEvent.View,
        gif: props.gifId,
        position: props.position,
        source: props.source,
        boosted: props.boosted,
        username: props.userName,
        fullscreen: props.fullscreen,
      });
    } catch (err) {
      console.error("Error sending metrics.");
    }
  }

  async sendGifPlayback(props: GifPlaybackEvent): Promise<void> {
    try {
      await apiMain.sendGifMetrics({
        event: GifMetricsEvent.Playback,
        username: props.userName,
        duration: props.duration, // in ms
        gif: props.gif,
        source: props.source,
        source_id: props.sourceId,
        boosted: props.boosted,
        position: props.position,
        play_count: props.playCount,
        start_position: props.startPoint,
      });
    } catch (err) {
      console.error("Error sending metrics.");
    }
  }

  async sendGifShared(props: GifSharedEvent): Promise<void> {
    try {
      await apiMain.sendGifMetrics({
        event: GifMetricsEvent.Share,
        gif: props.gifId,
        source: props.source,
        source_id: props.sourceId,
        boosted: props.boosted,
        position: props.position,
        play_count: props.playCount,
      });
    } catch (err) {
      console.error("Error sending metrics.");
    }
  }

  async sendGifAddedToCollection(props: AddedToCollectionEvent): Promise<void> {
    try {
      await apiMain.sendGifMetrics({
        event: GifMetricsEvent.AddToCollection,
        gif: props.gifId,
        source: props.source,
        source_id: props.sourceId,
        boosted: props.boosted,
        position: props.position,
        play_count: props.playCount,
      });
    } catch (err) {
      console.error("Error sending metrics.");
    }
  }

  async sendGifLiked(props: GifLikedEvent): Promise<void> {
    try {
      await apiMain.sendGifMetrics({
        event: GifMetricsEvent.Like,
        gif: props.gifId,
        source: props.source,
        source_id: props.sourceId,
        boosted: props.boosted,
        position: props.position,
        play_count: props.playCount,
      });
    } catch (err) {
      console.error("Error sending metrics.");
    }
  }

  async sendProfileClicked(props: ProfileClickedEvent): Promise<void> {
    try {
      await apiMain.sendGifMetrics({
        event: GifMetricsEvent.OpenProfile,
        gif: props.gifId,
        source: props.source,
        source_id: props.sourceId,
        position: props.position,
        play_count: props.playCount,
      });
    } catch (err) {
      console.error("Error sending metrics.");
    }
  }

  async sendFollowUserClicked(props: FollowUserClickedEvent): Promise<void> {
    try {
      await apiMain.sendGifMetrics({
        event: GifMetricsEvent.FollowUser,
        username: props.userName,
        source: props.source,
        source_id: props.sourceId,
        position: props.position,
        play_count: props.playCount,
      });
    } catch (err) {
      console.error("Error sending metrics.");
    }
  }
}

export default new LocalMetrics();
